export default function PerformantaScolaraPage() {

  const files = [
    "REZULTATE LA  CONCURSURILE ȘI OLIMPIADELE  ȘCOLARE ANUL ȘCOLAR  2024.pdf",
    "Centralizator_rezultate_olimpiade_concursuri_2025_2026.pdf",
  ];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-4">

        <div className="space-y-1 mt-5">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/educatie/performantaScolara/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}